module.exports = __webpack_public_path__ + "img/four-star-charity_navigator-480w.1127efa3.jpg";